import { cn } from "@/lib/utils";

// Sticky page header with a refined display font and airy spacing.
export function PageHeader({ title, description, actions, sticky = false, className }) {
  return (
    <div
      data-testid="page-header"
      className={cn(
        "flex flex-col gap-4 border-b border-border/60 pb-6 sm:flex-row sm:items-start sm:justify-between",
        sticky &&
          "sticky top-16 z-20 -mx-4 border-b border-border/60 bg-background/75 px-4 pb-4 pt-4 backdrop-blur-xl sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8",
        className
      )}
    >
      <div className="min-w-0">
        <h1 className="font-display text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
          {title}
        </h1>
        {description && (
          <p className="mt-2 max-w-2xl text-sm text-muted-foreground sm:text-[15px]">{description}</p>
        )}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
